<script setup>
import cat from '@images/cat.jpg'
import facebook from '@images/social-media/facebook.png'
import instagram from '@images/social-media/instagram.png'
import linkedin from '@images/social-media/linkedin.png'
import twitter from '@images/social-media/twitter.png'
import { reactive } from 'vue'
import { VForm } from 'vuetify/components/VForm'

definePage({
  meta: {
    layout: 'blank',
    public: true,
  },
})

const state = reactive({
  text: {
    textarea: '',
  },
})

const refForm = ref()
</script>

<template>
  <VContainer>
    <VForm ref="refForm">
      <VCard class="mb-6">
        <VCardText>
          <VRow>
            <VCol
              cols="12"
              md="12"
            >
              <AppTextarea
                v-model="state.text.textarea"
                placeholder="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vel faucibus nisi"
              />
            </VCol>
            <VCol
              cols="12"
              md="12"
            >
              <div class="fo-textbtn-area">
                <VBtn>
                  COPY TEXT
                </VBtn>
                <VImg :src="cat" />
                <VBtn class="fo-grey">
                  DOWNLOAD IMAGE
                </VBtn>
              </div>
            </VCol>
            <VCol
              cols="12"
              md="12"
            >
              <div class="fo-social">
                <a href="javascript:void(0);">
                  <VImg :src="facebook" />
                </a>
                <a href="javascript:void(0);">
                  <VImg :src="twitter" />
                </a>
                <a href="javascript:void(0);">
                  <VImg :src="linkedin" />
                </a>
                <a href="javascript:void(0);">
                  <VImg :src="instagram" />
                </a>
              </div>
            </VCol>
          </VRow>
        </VCardText>
      </VCard>
    </VForm>
  </VContainer>
</template>
